// Coinbase public endpoints, no key: spot price plus 24h stats. Stablecoins are quoted for real (USDC depegged in 2023).
import { t } from '@/i18n';
import type { Quote } from '@/types';
import { MarketError, marketFetch } from './errors';

export async function coinbaseQuote(symbol: string, signal?: AbortSignal): Promise<Quote> {
  const pair = `${symbol.toUpperCase()}-USD`;
  const spot = (await (await marketFetch(`https://api.coinbase.com/v2/prices/${pair}/spot`, { signal }, 'Coinbase')).json()) as { data?: { amount?: string } };
  const price = Number(spot.data?.amount);
  if (!Number.isFinite(price) || price <= 0) throw new MarketError('not_found', t('err.noQuote', { label: 'Coinbase', symbol: pair }));

  let change: number | undefined;
  let changePct: number | undefined;
  let previousClose: number | undefined;
  let high: number | undefined;
  let low: number | undefined;
  try {
    const stats = (await (await marketFetch(`https://api.exchange.coinbase.com/products/${pair}/stats`, { signal }, 'Coinbase')).json()) as { open?: string; high?: string; low?: string };
    const open = Number(stats.open);
    if (Number.isFinite(open) && open > 0) {
      previousClose = open;
      change = price - open;
      changePct = (change / open) * 100;
    }
    const pos = (v: string | undefined) => (Number(v) > 0 ? Number(v) : undefined);
    high = pos(stats.high);
    low = pos(stats.low);
  } catch {
    // 24h stats are a nicety; the spot price alone is fine.
  }
  return { key: `cx:${symbol.toUpperCase()}`, price, currency: 'USD', asOf: Date.now(), change, changePct, previousClose, open: previousClose, high, low, source: 'coinbase', freshness: 'realtime', stale: false };
}
